import { render, staticRenderFns } from "./EditCompanyForm.vue?vue&type=template&id=68950553"
import script from "./EditCompanyForm.vue?vue&type=script&lang=js"
export * from "./EditCompanyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports